module.exports = __webpack_public_path__ + "static/media/header_dropdown_arrow_down.ea556782.svg";